import { Card } from 'semantic-ui-react'
import styled, { css } from 'styled-components'

export const StyledCard = styled(({ borderColor, ...props }) => (
  <Card {...props} />
))`
  ${({ theme, size, borderColor }) => css`
    &&& {
      height: auto !important;
      color: ${theme.primaryFontColor};
      border: 1px solid #e6e8eb;
      box-shadow: none !important;
      border-bottom: ${borderColor
        ? `1px solid ${borderColor}`
        : '1px solid #e6e8eb'};
      border-radius: 8px;

      .header {
        font-weight: normal !important;
      }

      > .content {
        flex-grow: 0;

        &:nth-child(2) {
          overflow: auto;
          overflow-x: hidden;
          height: ${size === 'fixed' ? '230px' : 'initial'};
          padding-bottom: 0;
        }
      }
      .top-content img {
        object-position: top center;
      }

      .extra {
        margin: 1rem 0;
      }

      a& {
        transition: transform 0.1s ease-in-out;
      }

      a&:hover {
        border: 1px solid #e6e8eb;
      }
    }
  `}
`

export const CardWithTopBorder = styled(StyledCard)`
  &&&.blue {
    border-top: 5px solid #2185d0;
  }

  &&&.yellow {
    border-top: 5px solid #fbbd08;
  }

  &&&.green {
    border-top: 5px solid #21ba45;
  }

  &&&.red {
    border-top: 5px solid #d01919;
  }
`

export const StyledGroup = styled(Card.Group)`
  ${({ theme }) => theme.mediaQueries.mobile} {
    &&& > .card.card:first-child {
      margin-top: 1em !important;
    }
  }
`

export const StyledHeader = styled(Card.Header)`
  color: ${props => props.theme.primaryFontColor} !important;
`
